import merge from 'lodash.merge';
import useAnalytics from "./useAnalytics";
export default (function (globalConfig) {
  var analytics = useAnalytics();
  return function (configFn) {
    return function () {
      analytics && analytics.push(function (dataLayer) {
        return merge({
          type: 'click'
        }, globalConfig ? globalConfig(dataLayer) : {}, configFn ? configFn(dataLayer) : {});
      });
    };
  };
});